/* Award logo popover/modal. Any element with [data-award] and
   data-award-title / data-award-body (and optionally data-award-logo) becomes a
   trigger. Desktop = hover popover next to the logo; mobile = tap modal + close. */
(function () {
  "use strict";
  if (!document.querySelector("[data-award]")) return;

  var el = document.createElement("div");
  el.className = "awm";
  el.innerHTML =
    '<div class="awm__backdrop" data-awm-close></div>' +
    '<div class="awm__card" role="dialog" aria-label="Award">' +
      '<button class="awm__x" type="button" data-awm-close aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<img class="awm__logo" alt="">' +
      '<div class="awm__text"><div class="awm__title"></div><div class="awm__body"></div></div>' +
    '</div>';
  document.body.appendChild(el);

  var card = el.querySelector(".awm__card");
  var logo = el.querySelector(".awm__logo");
  var title = el.querySelector(".awm__title");
  var body = el.querySelector(".awm__body");
  var mq = window.matchMedia("(max-width: 749px)");         // hover popover vs tap modal
  var current = null, closeTimer = null;
  function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(close, 90); }

  function fill(trigger) {
    var img = trigger.querySelector("img");
    var desktop = trigger.getAttribute("data-award-logo") || (img && (img.currentSrc || img.src)) || "";
    var mobile = trigger.getAttribute("data-award-logo-mobile") || "";
    // The popup always shows the dedicated popup/mobile logo when one is set.
    logo.src = mobile || desktop;
    var t = trigger.getAttribute("data-award-title") || "";
    var b = trigger.getAttribute("data-award-body") || "";
    title.textContent = t; title.style.display = t ? "" : "none";
    body.textContent = b; body.style.display = b ? "" : "none";
  }

  function openModal(trigger) {   // mobile
    fill(trigger);
    card.style.top = ""; card.style.left = "";
    el.classList.add("is-open", "is-modal");
  }

  function openPopover(trigger) { // desktop hover
    clearTimeout(closeTimer);
    if (current === trigger && el.classList.contains("is-open")) return;
    current = trigger;
    fill(trigger);
    el.classList.remove("is-modal");
    el.classList.add("is-open");
    // Position beside/below the logo, clamped to the viewport.
    card.style.top = "0px"; card.style.left = "0px";
    var r = trigger.getBoundingClientRect();
    var cw = card.offsetWidth, ch = card.offsetHeight;
    var left = r.left + r.width / 2 - cw / 2;
    left = Math.max(10, Math.min(left, window.innerWidth - cw - 10));
    var top = r.bottom + 10;
    if (top + ch > window.innerHeight - 10) top = Math.max(10, r.top - ch - 10);
    card.style.left = left + "px";
    card.style.top = top + "px";
  }

  function close() { el.classList.remove("is-open", "is-modal"); current = null; }

  // Desktop: hover in/out on a logo.
  document.addEventListener("mouseover", function (e) {
    if (mq.matches) return;
    var t = e.target.closest("[data-award]");
    if (t) openPopover(t);
  });
  document.addEventListener("mouseout", function (e) {
    if (mq.matches) return;
    var t = e.target.closest("[data-award]");
    if (t && !t.contains(e.relatedTarget)) scheduleClose();
  });

  // Mobile: tap a logo to open; close button / backdrop / Esc to dismiss.
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-awm-close]")) { close(); return; }
    if (!mq.matches) return;
    var t = e.target.closest("[data-award]");
    if (t) { e.preventDefault(); openModal(t); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  window.addEventListener("resize", function () { if (el.classList.contains("is-open") && !mq.matches && current) openPopover(current); });
})();
